import { render, staticRenderFns } from "./BaseExamForm.vue?vue&type=template&id=f77af522&"
import script from "./BaseExamForm.vue?vue&type=script&lang=js&"
export * from "./BaseExamForm.vue?vue&type=script&lang=js&"
import style0 from "./BaseExamForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports